/**
 * Inject the standard GTM snippet once. Consent Mode defaults (denied) are set
 * in google-consent-mode.js before OneTrust runs.
 */
export function initGtm(containerId) {
	if (typeof window === 'undefined' || !containerId || window.__delightGtmInitialized) {
		return
	}

	window.__delightGtmInitialized = true

	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

	const script = document.createElement('script')
	script.async = true
	script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`
	document.head.appendChild(script)

	// This client-only loader requires JavaScript. A dynamically created
	// noscript iframe can issue a request outside the consent-gated tags,
	// so there is no no-JavaScript fallback to inject here.
}
